module.exports = __webpack_public_path__ + "img/w26-b3.7f478094.jpg";